import { data } from '../../svg/Upload/data';
import { makeIcon } from '../makeIcon';

export const Upload = makeIcon(data, 'upload', 'Upload');

export default Upload;
